import { render, staticRenderFns } from "./DeleteStoreUser.vue?vue&type=template&id=59150140"
import script from "./DeleteStoreUser.vue?vue&type=script&lang=js"
export * from "./DeleteStoreUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports